
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/chart",
      function () {
        return require("private-next-pages/embed/chart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/chart"])
      });
    }
  